// table name -> feature key name
enum pageFeatures {
  'payments' = 'feature__payments',
}

export default pageFeatures;
